import { BaseRepresentativeClientEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';

import { RepresentativeClientMainInfoType } from '../types';

const getRepresentativeClientMainInfoForGlobal = (
  representativeClient: BaseRepresentativeClientEntity
): RepresentativeClientMainInfoType => ({
  citizenship: representativeClient.citizenships?.[0],
  country: representativeClient.residentialAddress?.country,
  phone: representativeClient.phone,
  email: representativeClient.email,
  basisForRepresentationDocumentNumber:
    representativeClient.basisForRepresentation?.documentNumber,
  basisForRepresentationDocumentExpirationDate:
    representativeClient.basisForRepresentation?.dateOfExpiration,
});

const getRepresentativeClientMainInfoForFinance = (
  representativeClient: BaseRepresentativeClientEntity
): RepresentativeClientMainInfoType => ({
  country: representativeClient.registrationAddress?.country,
  phone: representativeClient.phone,
  email: representativeClient.email,
  basisForRepresentationDocumentNumber:
    representativeClient.basisForRepresentation?.documentNumber,
  basisForRepresentationDocumentExpirationDate:
    representativeClient.basisForRepresentation?.dateOfExpiration,
});

export const getRepresentativeClientMainInfo = (
  representativeClient: BaseRepresentativeClientEntity
): RepresentativeClientMainInfoType | undefined => {
  if (isGlobalProject()) {
    return getRepresentativeClientMainInfoForGlobal(representativeClient);
  }

  if (isFinanceProject()) {
    return getRepresentativeClientMainInfoForFinance(representativeClient);
  }

  return undefined;
};
